import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { set } from "js-cookie";

let MobileMenuOptions = {
  bodyClassMenuUnhide: "unhideMenu",
  bodyClassMenuOpen: "showMenu",
  elementsClassPushed: "showMenuPushed",
  selectedItemClass: "selected",
  subMenu: ".subMenu",
  scrollableClass: "scrollable"
};

class MobileMenu extends Class {
  constructor(element, options) {
    super();
    this.setOptions(MobileMenuOptions, options);
    this.setUpElements(element);
    this.addClassesToPushedElements();
    this.setUpEvents();
    $(this).trigger("loaded", this);
  }

  setUpElements(element) {
    this.element = $(element);
    this.body = $("body");
    this.toggle = this.body.find("[data-menu-toggle-button]");
    this.pushed = this.body.find("[data-menu-open-pushed]");
    this.mobileMenuClose = this.body.find(".mobileMenuClose");
    this.close = this.element.find(".menuClose");
    this.ul = this.element.find("ul");
    this.ulsub = this.element.find("ul.subMenu");
    this.parentItem = this.element.find(".hasChildren > a");
    this.backItem = this.element.find(".parentBack > a");
    this.buttonContext = null;
    this.winHeight = $(window).height() - $(".mast").height();
    
  }

  setUpEvents() {
    this.setUpToggleMenuEvent();
    this.setUpCloseMenuEvent();
    this.setUpShowSubMenuEvent();
    this.setUpHideSubMenuEvent();  
    this.focusOnsubMenu();
  }

  addClassesToPushedElements() {
    this.pushed.addClass(this.options.elementsClassPushed);
  }

  setUpToggleMenuEvent() {
    var self = this;
    this.toggle.on("click", function(evt) {
      self.buttonContext = this;
      self.toggleMenu();
      evt.preventDefault();
      if ($(this).attr("aria-expanded") === "true") {
        $("#mobilemenu").removeClass("preventScroll");
      }
    });
  }

  setUpCloseMenuEvent() {
    var self = this;
    this.close.on("click", function(evt) {
      evt.preventDefault();
      self.closeMenu();
      $(this)
        .closest("#mobilemenu")
        .removeClass("preventClass");
    });
    this.mobileMenuClose.on("click", function() {
      self.closeMenu();
    });
  }

  focusOnsubMenu(){
    var self = this;
    self.parentItem.each(function(evt,element){
      $(element).on('keydown', function(e){
        
        if(e.key === "Enter"){
            var submenu = $(e.target).next().children();
           
            var firstEl = submenu[0].children[0];
            var lastEl = submenu[submenu.length-1].children[0];
         
            submenu.on('keydown', function(evt) { 
              /* shift + tab */
                if (evt.shiftKey && evt.key==='Tab'){
                  setTimeout(function(){

                    if (evt.target == firstEl){
                      lastEl.focus();
                    }
                  },30);
                }
                 if(evt.key === 'Tab' && !evt.shiftKey ){
                   var targetElm = $(this).next().children('a'); 
                   setTimeout(function(){
                     if (targetElm[0] == undefined) {
                        firstEl.focus();
                      }
                    },20)
                }  
            });
        }
      })
    })

  }
  setUpShowSubMenuEvent() {
    var self = this;
 
    this.parentItem.each(function(index, element) {
    
      $(element).on("click", function(evt) {
        $(this)
          .closest("#mobilemenu")
          .addClass("preventScroll");
        $(this)
          .closest("ul")
          .scrollTop(0);
        var $self = $(this),
          $parent = $self.parent();
        var firstSubNav = $(this).next(self.options.subMenu);
        firstSubNav.removeClass("hide");

        var childLIs = firstSubNav.find(">li"),
          originalHeight = self.winHeight,
          collectiveHeight = (function() {
            let arrLIHeights = [];
            childLIs.each((ind, ele) => arrLIHeights.push($(ele).height()));
            let total = arrLIHeights.reduce((sum, value) => sum + value);
            return total;
          })();

        if (originalHeight > collectiveHeight) {
          $(this)
            .next(self.options.subMenu)
            .css("height", "100vh - 52px");
        }

        $self.attr("aria-expanded", true);
        setTimeout(function() {
          $parent.addClass(self.options.selectedItemClass);
        }, 10);
        self.ariaHiddenDisplay(false, $parent);
        setTimeout(function() {
          $parent
            .find(self.options.subMenu)
            .find(":focusable")
            .first()
            .focus();
           
        }, 300);
        evt.stopPropagation();
        evt.preventDefault();
      });
    });
  }

  setUpHideSubMenuEvent() {
    var self = this;
    this.backItem.on("click", function(evt) {
      if (
        !$(this)
          .closest("li.selected")
          .parent()
          .hasClass("subMenu")
      ) {
        $(this)
          .closest("#mobilemenu")
          .removeClass("preventScroll");
      }
      var $parent = $(this)
        .parent()
        .parent();
      $parent.parent(".selected").removeClass(self.options.selectedItemClass);
      setTimeout(function() {
        $parent.addClass("hide");
        $parent
          .parents(".hasChildren")
          .first()
          .children("a")
          .attr("aria-expanded", false)
          .focus();
      }, 300);
      self.ariaHiddenDisplay(true, this);
      evt.stopPropagation();
    });
  }

  ariaHiddenDisplay(hide, element) {
    if (!hide) {
      $(element)
        .find(this.options.subMenu)
        .first()
        .attr("aria-hidden", false);
    } else {
      $(element)
        .parents(this.options.subMenu)
        .first()
        .attr("aria-hidden", true);
    }
  }

  closeMenu() {
    var self = this;
    this.body.removeClass(this.options.bodyClassMenuOpen);
    this.toggle.attr("aria-expanded", false);
    this.element.attr("aria-hidden", true);
    if (this.buttonContext) {
      this.buttonContext.focus();
    }
    setTimeout(function() {
      self.body.removeClass(self.options.bodyClassMenuUnhide);
      self.resetMenu();
    }, 300);
  }

  openMenu() {
    var self = this;
    this.body.addClass(this.options.bodyClassMenuUnhide);
    setTimeout(function() {
      self.body.addClass(self.options.bodyClassMenuOpen);
    }, 10);
    this.toggle.attr("aria-expanded", true);
    this.element.attr("aria-hidden", false);
    this.element
      .find(":focusable")
      .first()
      .focus();
      this.trapFocus(this.element.find(':focusable'));
  }

  toggleMenu() {
    if (this.body.hasClass(this.options.bodyClassMenuOpen)) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  resetMenu() {
    this.parentItem.parent().removeClass("selected");
    this.ul
      .find(this.options.subMenu)
      .attr("aria-hidden", true)
      .addClass("hide");
  }

  trapFocus(element){
    if(element.length){
      let firstEl = element[0];
      let lastEl = element[element.length - 1];
      element.on('keydown', function(e) { 
         /* shift + tab */
           if ( e.shiftKey  )  {
               if (e.target === firstEl) {
                   lastEl.focus();
                   e.preventDefault();
               }
           }else if(e.keyCode === 9){ 
               if (e.target === lastEl) { 
                 firstEl.focus();
                 e.preventDefault();
             }
           }  
       });
     }
  }

}

export { MobileMenu };



// WEBPACK FOOTER //
// ./Javascript/core/classes/menu/mobile.menu.class.js